var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "order-card" }, [
    _c("header", { staticClass: "header" }, [
      _c("h1", [_vm._v("Order Details")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("#" + _vm._s(_vm.order.id) + " "),
        _vm.isShowOrderDate
          ? _c("em", [
              _vm._v("Ordered " + _vm._s(_vm._f("date")(_vm.order.date)))
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("article", [
      _c(
        "section",
        { staticClass: "section summary" },
        [
          _c("div", { staticClass: "summary__left" }, [
            _c("section", { staticClass: "detail ticket" }, [
              _c("h3", { staticClass: "section__heading" }, [
                _vm._v("Ticket Summary")
              ]),
              _vm._v(" "),
              _vm.order.event.status === _vm.EVENT_STATUS.RESCHEDULED &&
              [
                _vm.ORDER_STATUS.CREATED,
                _vm.ORDER_STATUS.PENDING,
                _vm.ORDER_STATUS.PROCESSED,
                _vm.ORDER_STATUS.SENT_TO_BUYER
              ].includes(_vm.order.current_status)
                ? _c(
                    "div",
                    { staticClass: "ticket__rescheduled-notification" },
                    [
                      _c("span", {
                        staticClass:
                          "ticket__rescheduled-notification-icon icon-email-2"
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "For the most up-to-date event information please refer to your email"
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h4", { staticClass: "ticket__event-name" }, [
                _vm._v(_vm._s(_vm.order.event.name))
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "ticket__event" },
                [
                  [
                    _vm.ORDER_STATUS.CREATED,
                    _vm.ORDER_STATUS.PENDING,
                    _vm.ORDER_STATUS.PROCESSED,
                    _vm.ORDER_STATUS.SENT_TO_BUYER
                  ].includes(_vm.order.current_status)
                    ? [
                        _vm.order.event.status &&
                        _vm.order.event.status !== _vm.EVENT_STATUS.SCHEDULED
                          ? _c("Tag", {
                              staticClass: "ticket__event-status",
                              attrs: {
                                context: "status",
                                text: _vm.eventStatusCopy(_vm.order)
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        [
                          _vm.EVENT_STATUS.TBD,
                          _vm.EVENT_STATUS.POSTPONED
                        ].includes(_vm.order.event.status)
                          ? _c("span", [
                              _vm._v("Event updates will be emailed")
                            ])
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm._f("date")(
                                    _vm.order.event.local_date,
                                    "ddd MMM D, YYYY"
                                  )
                                ) +
                                  " at " +
                                  _vm._s(
                                    _vm._f("date")(
                                      _vm.order.event.local_date,
                                      "h:mma"
                                    )
                                  )
                              )
                            ]
                      ]
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("date")(
                              _vm.order.event.local_date,
                              "ddd MMM D, YYYY"
                            )
                          ) +
                            " at " +
                            _vm._s(
                              _vm._f("date")(
                                _vm.order.event.local_date,
                                "h:mma"
                              )
                            )
                        )
                      ],
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.order.event.venue.name) +
                      ",\n                        " +
                      _vm._s(_vm.cityAndStateInfo)
                  ),
                  _vm.order.event.venue.subdivision
                    ? [_vm._v(", " + _vm._s(_vm.order.event.venue.subdivision))]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "detail seat" }, [
              _c("div", { staticClass: "seat__details" }, [
                _c("div", { staticClass: "seat__detail" }, [
                  _c("h4", { staticClass: "detail__heading" }, [
                    _vm._v("Section")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "detail__body detail__body--seat" }, [
                    _vm._v(_vm._s(_vm.order.ticket.section))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "seat__detail" }, [
                  _c("h4", { staticClass: "detail__heading" }, [_vm._v("Row")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "detail__body detail__body--seat" }, [
                    _vm._v(_vm._s(_vm.order.ticket.row))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "seat__detail" }, [
                  _c("h4", { staticClass: "detail__heading" }, [_vm._v("Qty")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "detail__body detail__body--seat" }, [
                    _vm._v(_vm._s(_vm.order.ticket.quantity))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.order.ticket.notes
              ? _c("section", { staticClass: "detail" }, [
                  _c("h3", { staticClass: "detail__heading" }, [
                    _vm._v("Seller Notes")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "detail__body" }, [
                    _vm._v(_vm._s(_vm.order.ticket.notes))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.order.event.disclaimer
              ? _c("section", { staticClass: "detail" }, [
                  _c("h3", { staticClass: "detail__heading" }, [
                    _vm._v("Event Disclaimer")
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "detail__body",
                    domProps: { innerHTML: _vm._s(_vm.order.event.disclaimer) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("section", { staticClass: "inventory-supplier" }, [
              _c("img", {
                staticClass: "inventory-supplier__logo",
                class: {
                  "inventory-supplier__logo--primary":
                    _vm.order.ticket.is_primary
                },
                attrs: {
                  alt: _vm.order.ticket.is_primary
                    ? _vm.$config.primaryInventorySupplier.checkout.alt
                    : "Powered by VividSeats",
                  src: _vm.order.ticket.is_primary
                    ? _vm.$store.state.imagesCdn +
                      "/" +
                      _vm.$config.primaryInventorySupplier.checkout
                        .staticImagePath
                    : _vm.$store.state.imagesCdn + "/powered_by_VS_V2.svg"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.config.isIntegrated
            ? [
                _c("vsOrderCardDeliveryDetails", {
                  attrs: { order: _vm.order }
                })
              ]
            : [
                _c("fxOrderCardDeliveryDetails", {
                  attrs: { order: _vm.order }
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      !_vm.partnerIsPurchaser
        ? _c("section", { staticClass: "section billing" }, [
            _c("h3", { staticClass: "section__heading" }, [
              _vm._v("Billing Summary")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "billing__row" }, [
              _vm.billingAddress
                ? _c("div", { staticClass: "billing__col" }, [
                    _c("section", { staticClass: "detail" }, [
                      _c("h4", { staticClass: "detail__heading" }, [
                        _vm._v("Billing Address")
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "detail__body" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.billingAddress.first_name) +
                              " " +
                              _vm._s(_vm.billingAddress.last_name) +
                              "\n                            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.billingAddress.address_line_1) +
                              "\n                            "
                          ),
                          _vm.billingAddress.address_line_2
                            ? [
                                _vm._v(
                                  ", " +
                                    _vm._s(_vm.billingAddress.address_line_2)
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.billingAddress.address_line_3
                            ? [
                                _vm._v(
                                  ", " +
                                    _vm._s(_vm.billingAddress.address_line_3)
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.billingAddress.city) +
                              ", " +
                              _vm._s(_vm.billingAddress.region) +
                              "\n                            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.billingAddress.postal_code) +
                              "\n                        "
                          )
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.billingAddress.phone_number
                      ? _c("section", { staticClass: "detail" }, [
                          _c("h4", { staticClass: "detail__heading" }, [
                            _vm._v("Phone Number")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "detail__body" }, [
                            _vm._v(_vm._s(_vm.billingAddress.phone_number))
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.order.payment && _vm.order.payment.paid > 0
                ? _c("div", { staticClass: "billing__col" }, [
                    _c("section", { staticClass: "detail" }, [
                      _c("h4", { staticClass: "detail__heading" }, [
                        _vm._v("Payment Method")
                      ]),
                      _vm._v(" "),
                      _vm.creditCardType
                        ? _c(
                            "p",
                            { staticClass: "detail__body detail__body--logo" },
                            [
                              _c("img", {
                                staticClass:
                                  "billing__logo billing__logo--credit-card",
                                attrs: {
                                  alt: _vm.creditCardType.displayName,
                                  src:
                                    "" +
                                    _vm.$store.state.imagesCdn +
                                    _vm.creditCardType.iconSlug
                                }
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.creditCardType.displayName) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm.payPalBuyerEmail
                        ? _c(
                            "p",
                            { staticClass: "detail__body" },
                            [
                              _c("PaypalLogo", {
                                staticClass:
                                  "billing__logo billing__logo--paypal"
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "billing__paypal-email" },
                                [_vm._v(_vm._s(_vm.payPalBuyerEmail))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "detail" }, [
                      _c("h4", { staticClass: "detail__heading detail" }, [
                        _vm._v("Total Payment")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "detail__body" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("numeral")(_vm.order.payment.paid, "$0,0.00")
                          ) +
                            " " +
                            _vm._s(_vm.order.payment.currency)
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowPointsEarned || _vm.isShowPointsRedeemed
                ? _c("div", { staticClass: "billing__col" }, [
                    _vm.isShowPointsRedeemed
                      ? _c("section", { staticClass: "detail" }, [
                          _c("h4", { staticClass: "detail__heading" }, [
                            _vm._v("Rewards Redeemed")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "detail__body" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatPoints(
                                  _vm.order.loyalty.paid,
                                  _vm.order.loyalty.currency
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowPointsEarned
                      ? _c("section", { staticClass: "detail" }, [
                          _c("h4", { staticClass: "detail__heading" }, [
                            _vm._v("Rewards Earned")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "detail__body" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatPoints(
                                  _vm.order.loyalty.earn,
                                  _vm.order.loyalty.currency
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }